(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["insights-main-product"]) return;
  try {
    
(function () {
  var rows = document.querySelectorAll('[class*="tl-video-testimonials-row--"]');
  rows.forEach(function (row) {
    var track = row.querySelector('[data-tl-slider-track]');
    var dotsContainer = row.querySelector('[data-tl-slider-dots]');
    if (!track || !dotsContainer) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(dotsContainer.querySelectorAll('[data-tl-slider-dot]'));
    if (slides.length === 0 || dots.length === 0) return;

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = Number(dot.getAttribute('data-tl-slider-dot'));
        if (slides[idx]) {
          slides[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      });
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio >= 0.5) {
            var idx = slides.indexOf(entry.target);
            dots.forEach(function (d) { d.removeAttribute('data-active'); });
            if (dots[idx]) dots[idx].setAttribute('data-active', 'true');
          }
        });
      },
      { root: track, threshold: 0.5 }
    );
    slides.forEach(function (s) { io.observe(s); });

    if (dots[0]) dots[0].setAttribute('data-active', 'true');
  });
})();

  } catch(e) { console.error(e); }
})();
})();
